import React from "react";
import { Props } from "./types";
import styles from "./styles.scss";
import { DocumentIcon } from "@common/documentIcon";
import classNames from "classnames";
import { useRemoveAttachedDocument } from "@planzone/view-models";

function cropName(name: string, length: number): string {
  if (name.length <= length) {
    return name;
  }

  const halfLength = Math.floor((length - 3) / 2);
  const firstHalf = name.slice(0, halfLength);
  const secondHalf = name.slice(-halfLength);

  return `${firstHalf}...${secondHalf}`;
}
function DocumentCard({ document, openPreview, element, elementType }: Props) {
  const { removeAttachedDocument, isRequestPending } =
    useRemoveAttachedDocument(document.uuid);

  const onRemoveDocument = () => {
    if (!isRequestPending) {
      removeAttachedDocument({
        documentId: document.uuid,
        elementId: element.uuid,
        elementType,
      });
    }
  };

  return (
    <div className={classNames(styles.documentCard)}>
      <div className={styles.top}>
        <DocumentIcon
          mimeType={document.mimeType}
          className={styles.documentIcon}
        />
      </div>
      <div className={styles.bottom}>
        <DocumentIcon
          mimeType={document.mimeType}
          className={styles.documentIcon}
        />
        <div className={styles.documentInfo}>
          <p>{cropName(document.name, 15)}</p>
          <span>{new Date(document.createdDate).toLocaleDateString()}</span>
        </div>
      </div>
      <div className={styles.hoverContainer}>
        <button
          className={styles.removeButton}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            onRemoveDocument();
          }}
        >
          <svg
            fill="white"
            strokeWidth="0"
            viewBox="0 0 512 512"
            height="20px"
            width="20px"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M400 145.49 366.51 112 256 222.51 145.49 112 112 145.49 222.51 256 112 366.51 145.49 400 256 289.49 366.51 400 400 366.51 289.49 256 400 145.49z"></path>
          </svg>
        </button>
        <button
          className={styles.lenseButton}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            openPreview(document);
          }}
        >
          <svg
            stroke="white"
            fill="white"
            strokeWidth="0"
            viewBox="0 0 512 512"
            height="60px"
            width="60px"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M456.69 421.39 362.6 327.3a173.81 173.81 0 0 0 34.84-104.58C397.44 126.38 319.06 48 222.72 48S48 126.38 48 222.72s78.38 174.72 174.72 174.72A173.81 173.81 0 0 0 327.3 362.6l94.09 94.09a25 25 0 0 0 35.3-35.3zM97.92 222.72a124.8 124.8 0 1 1 124.8 124.8 124.95 124.95 0 0 1-124.8-124.8z" />
          </svg>
        </button>
      </div>
    </div>
  );
}

export { DocumentCard };
